// Dependecies
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams, useLocation } from 'react-router-dom';

// State
import locale from '../../store/locale';

// Helpers
import { makePath } from '../../helpers';

function useLanguage() {
  const { lang } = useParams();
  const history = useHistory();
  const location = useLocation();
  const [localeStore, localeAction] = locale();
  const [isEnglish, setIsEnglish] = useState(false);
  const [t, i18n] = useTranslation('routers', { useSuspense: false });

  useEffect(() => {
    if (lang !== localeStore.currentLocale && localeStore.componentName !== '') {
      history.push(makePath(localeStore.currentLocale, t(localeStore.componentName), location));
    }
  }, [localeStore.componentName]);

  useEffect(() => {
    i18n.changeLanguage(localeStore.currentLocale).then(() => {
      setIsEnglish(localeStore.currentLocale === 'en');
    });
  }, [localeStore.currentLocale]);

  const changeLanguage = (currentLocale) => {
    localeAction.changeLocale(currentLocale);
    i18n.changeLanguage(currentLocale).then(() => {
      history.push(makePath(i18n.language, t(localeStore.componentName), location));
    });
  };
  return {
    isEnglish,
    i18n,
    changeLanguage,
    componentName: localeStore.componentName,
    locale: localeStore.currentLocale,
  };
}

export default useLanguage;
